export default {
  title: 'Error Logs',
  cleanupOld: 'Cleanup Old',
  refresh: 'Refresh',
  selected: '{count} selected',
  markResolved: 'Mark Resolved',
  markOpen: 'Mark Open',
  clear: 'Clear',
  filters: {
    startDate: 'Start Date',
    endDate: 'End Date',
    errorType: 'Error Type',
    status: 'Status',
    searchPlaceholder: 'Search message or user'
  },
  headers: {
    type: 'Type',
    message: 'Message',
    user: 'User',
    timestamp: 'Timestamp',
    status: 'Status'
  },
  errorTypes: {
    javascript: 'JavaScript',
    vue: 'Vue',
    promise: 'Promise',
    manual: 'Manual',
    warning: 'Warning',
    info: 'Info'
  },
  statusOptions: {
    open: 'Open',
    resolved: 'Resolved'
  },
  anonymous: 'Anonymous',
  unknown: 'Unknown',
  noData: 'No error logs found',
  details: {
    title: 'Error Details',
    message: 'Message',
    errorName: 'Error Name',
    url: 'URL',
    route: 'Route',
    userAgent: 'User Agent',
    resolvedAt: 'Resolved At',
    context: 'Context',
    stackTrace: 'Stack Trace'
  },
  cleanup: {
    title: 'Cleanup Old Errors',
    description: 'This will permanently delete error logs older than {days} days.',
    daysToKeep: 'Days to keep',
    cancel: 'Cancel',
    delete: 'Delete'
  },
  snackbar: {
    loadFailed: 'Failed to load error logs',
    markedAsResolved: 'Error marked as resolved',
    markedAsOpen: 'Error marked as open',
    updateFailed: 'Failed to update error status',
    noErrorsSelected: 'No errors selected',
    bulkUpdateSuccess: '{count} errors marked as {status}',
    bulkUpdateFailed: 'Failed to bulk update errors',
    cleanupSuccess: 'Deleted {count} old error logs',
    cleanupFailed: 'Failed to cleanup old logs'
  },
  notAvailable: 'N/A'
}
